import { createContext, useContext, useEffect, useState } from "react";
const CartCtx = createContext(null);
const KEY = "gidza_cart";
export function CartProvider({ children }) {
  const [items, setItems] = useState(() => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }});
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);
  const add = (product) => setItems(prev => {
    const ex = prev.find(x => x.id === product.id);
    if (ex) return prev.map(x => x.id === product.id ? { ...x, qty: x.qty + 1 } : x);
    return [...prev, { id: product.id, name: product.name, price: product.price, image: product.image, qty: 1 }];
  });
  const remove = (id) => setItems(prev => prev.filter(x => x.id !== id));
  const setQty = (id, q) => setItems(prev => prev.map(x => x.id === id ? { ...x, qty: Math.max(1, q) } : x));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);
  return <CartCtx.Provider value={{ items, add, remove, setQty, clear, subtotal, count }}>{children}</CartCtx.Provider>;
}
export const useCart = () => useContext(CartCtx);
